import { render, staticRenderFns } from "./ReportStowage.vue?vue&type=template&id=08abb25a&"
import script from "./ReportStowage.vue?vue&type=script&lang=js&"
export * from "./ReportStowage.vue?vue&type=script&lang=js&"
import style0 from "./ReportStowage.vue?vue&type=style&index=0&id=08abb25a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports